<div class="alert-popup" *ngIf="popupVisible">
  <div class="main">
    <div style="margin-right: 2em; color: rgb(112, 112, 112); font-family: Roboto, 'Open Sans', Arial, Helvetica">
      <!-- <b>{{ 'alert_heading' | translate }}</b
      >: {{ 'alert_for_travellers' | translate }}: -->
      <b>{{ 'alert_heading' | translate }}</b
      >: <span [innerHTML]="'alert_for_travellers' | translate"></span>:

      <a
        target="_blank"
        href="https://seychelles.govtas.com"
        style="
          font-family: Roboto, 'Open Sans', Arial, Helvetica;
          font-size: 14px;
          color: rgb(112, 112, 112);
          text-decoration: underline;
          cursor: pointer;
          font-weight: normal;
        "
        >seychelles.govtas.com</a
      >. {{ 'be_aware' | translate }}.
    </div>
    <button class="alertbutton" (click)="closePopup()">OK</button>
  </div>
</div>
